import { fansupportPublic } from "../index";

export const getPoll = async ({ sportId, countryId, tournamentId, teamId, languageId, page, perPage}) => {
    try {
        return fansupportPublic.get('/poll',{ params: { 
            sportId,
            countryId,
            tournamentId,
            teamId,
            languageId,
            page,
            perPage
        }})   
    } catch (error) {
        console.log("getPoll",error);
    }    
} 